////////////////////////////////////////////////////////////////////////////
// GENERAL

import {listenerCount} from "events";
import SimpleBar from 'simplebar';

let lastFocus

////////////////////////////////////////////////////////////////////////////
if (typeof window.replace === "undefined") {
    window.replace = function (str, sstr, rstr) {
        if (str == null) {
            return "";
        }
        return str.split(sstr).join(rstr);
    };
}

if (typeof window.dispatchNewEvent === "undefined") {
    window.dispatchNewEvent = function (element, type) {
        if ("createEvent" in document) {
            // modern browsers, IE9+
            var e = document.createEvent("HTMLEvents");
            e.initEvent(type, false, true);
            element.dispatchEvent(e);
        } else {
            // IE 8
            var e = document.createEventObject();
            e.eventType = type;
            element.fireEvent("on" + e.eventType, e);
        }
    };
}

////////////////////////////////////////////////////////////////////////////
// JQUERY
////////////////////////////////////////////////////////////////////////////
$(document).ready(function (e) {
    onResize();
    onScroll();
    setScrolls();
    setMenuButton();
    setPeople();
    setShare();
    setTagGroupsPosition();
    initCustomScroll();
});

$(window).resize(function (e) {
    onResize();
    setTagGroupsPosition();
});

$(window).scroll(function (e) {
    onScroll();
});

const onResize = function () {
    if (window && document) {
        var vh = 0.01 * window.innerHeight;
        document.documentElement.style.setProperty("--coing-vh", vh + "px");
    }
    calcScrolls();
};

const ariaRead = function (str) {
    console.log('aria read: ' + str)
    document.getElementById("sr-only").innerText = str;
};
window.ariaRead = ariaRead;

const onScroll = function () {
    if (window && document) {
        var scrollTop =
            window.screenLeft ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
        var isScrolled = document.body.className.indexOf("scrolled") > -1;
        if (scrollTop && !isScrolled) {
            $("body").addClass("scrolled").trigger("scrollChanged", [true]);
        } else if (!scrollTop && isScrolled) {
            $("body").removeClass("scrolled").trigger("scrollChanged", [false]);
        }
    }
};

const changeMainMenuState = function (isOpen) {
    if (isOpen) {
        $("body").addClass("menu-open");
    } else {
        $("body").removeClass("menu-open");
    }
    var imgId = isOpen ? "menu-close" : "menu-open";
    $("#menu-button").attr("aria-pressed", isOpen.toString());
    $("#menu-button").attr("aria-expanded", isOpen.toString());
    $("#menu-button").attr("aria-label", $("#" + imgId).data('label-text'));
    //
    $("#main-menu").find('a').attr('aria-hidden', isOpen ? 'false' : 'true');
    $("#main-menu").find('a').attr('tabindex', isOpen ? '0' : '-1');
    //
    if (isOpen) {
        closeAllHoverMenus();
    }
}

const setMenuButton = function () {
    // buttons
    if ($("#menu-button").length > 0) {
        $("#menu-button")
            .on('click', () => changeMainMenuState(!$("body").hasClass("menu-open")))
            .on('blur', () => changeMainMenuState(false))
    }
    if ($("#main-menu").length > 0) {
        changeMainMenuState(false);
        $("#main-menu")
            .find("a")
            .on('blur', function (e) {
                changeMainMenuState(false);
            });
        $("#main-menu")
            .find("a")
            .on('focus', function (e) {
                changeMainMenuState(true);
            });
    }
    // plus menu
    if ($("#desktopPlusMenuButton").length > 0) {
        $("#desktopPlusMenuButton").on('click', function (e) {
            toggleHoverMenu($(this).find('.hover-menu'));
            const isOpen = $(this).find('hover-menu').hasClass('open');
            $(this).attr('aria-expanded', isOpen ? 'true' : 'false');
        })
            .on('blur', function (e) {
                toggleHoverMenu($(this).find('.hover-menu'), false);
                $(this).attr('aria-expanded', 'false');
            });
        $("#desktopPlusMenuButton").on('keydown', function (e) {
            if (e.key === 'Enter') {
                toggleHoverMenu($(this).find('.hover-menu'));
                const isOpen = $(this).find('hover-menu').hasClass('open');
                $(this).attr('aria-expanded', isOpen ? 'true' : 'false');
            }
        });
    }
    $('.footer-mobile-toggle-menu').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
        } else {
            $('.footer-mobile-toggle-menu').removeClass('open');
            $(this).addClass('open');
        }
    });

    $('body').on('scrollChanged', () => {
        $('.footer-mobile-toggle-menu.open').removeClass('open')
    })

    $('.footer-mobile-toggle-menu ~ .background').on('click', function (e) {
        $(this).siblings('.footer-mobile-toggle-menu.open').removeClass('open');
    })
};

const setScrolls = function () {
    calcScrolls();
    // buttons
    if ($(".scroll-arrow").length > 0) {
        $(".scroll-arrow").click(onScrollButtonClick);
    }
};

window.calcScrolls = function () {
    if ($(".scroll-arrow").length > 0) {
        $(".scroll-wrapper").each(function (i, elem) {
            elem = $(elem);
            var holderW = elem.find(".scroll-slider").width();
            var items = elem.find(".scroll-slider").find(">li,>div:not(.no-results)");
            if (items.length) {
                var itemW =
                    items.eq(0).width() +
                    Number(
                        items.eq(0).css("margin-left").replace("px", "").replace("%", "")
                    ) +
                    Number(
                        items.eq(0).css("margin-right").replace("px", "").replace("%", "")
                    );
            }
            if (items.length * itemW <= holderW + 1) {
                elem.addClass("hide-arrows");
            } else {
                elem.removeClass("hide-arrows");
            }
        });
    }
};

const onScrollButtonClick = function (e) {
    var dir = -1;
    if (this.className.indexOf("next") > -1) {
        dir = 1;
    }
    //
    var langDir = document.documentElement.getAttribute("dir") === "ltr" ? -1 : 1;
    //
    var wrapper = $(this).parent().find(".scroll-wrapper").eq(0);
    var slider = wrapper.find(".scroll-slider").eq(0);
    var cols = Math.round(wrapper.attr("data-cols"));
    var total = slider.find(">li,>div:not(.no-results)").length;
    var pages = Math.floor((total - 1) / cols) + 1;
    var pos = Math.round(wrapper.attr("data-pos") || 0);
    pos += dir;
    if (pos > pages - 1) {
        pos = 0;
    } else if (pos < 0) {
        pos = pages - 1;
    }
    wrapper.attr("data-pos", pos);
    slider.css("transform", "translateX(" + 100 * pos * langDir + "%)");
};

const onEnterDispatchClick = function (e) {
    if (e.code === 'Enter' || e.code === 'Space') {
        $(e.currentTarget).click();
    }
}
window.onEnterDispatchClick = onEnterDispatchClick;

const scrollToListItem = function (parentClass, id) {
    if (parentClass) {
        const parent = $(`.${parentClass}`);
        if (parent.length) {
            if (id) {
                const elem = parent.find(`li[data-key="${id}"]`);
                if (elem.length) {
                    const elemRect = elem[0].getBoundingClientRect();
                    const list = elem.parent('ul');
                    const listRect = list[0].getBoundingClientRect();
                    if (list[0].scrollHeight > list[0].offsetHeight) {
                        //vertical
                        const elemTop = Math.round(elemRect.top - listRect.top + list[0].scrollTop);
                        const ypos = Math.round(elemTop + (elem[0].offsetHeight / 2) - (list[0].offsetHeight / 2));
                        list[0].scrollTop = ypos;
                        markListItem(parentClass, id);
                        return true;
                    } else if (list[0].scrollWidth > list[0].offsetWidth) {
                        // horizontal
                        const elemLeft = Math.round(elemRect.left - listRect.left + list[0].scrollLeft);
                        const xpos = Math.round(elemLeft + (elem[0].offsetWidth / 2) - (list[0].offsetWidth / 2));
                        list[0].scrollLeft = xpos;
                        markListItem(parentClass, id);
                        return true;
                    }
                }
            }
            parent[0].scrollTo(0, 0);
            markListItem(parentClass);
        }
    }
    return false;
}
window.scrollToListItem = scrollToListItem;

const filterListItems = function (parentClass, attr, value) {
    if (parentClass) {
        const parent = $(`.${parentClass}`);
        if (parent.length) {
            if (attr && value) {
                parent.find('li').css('display', 'none');
                parent.find(`li[${attr}="${value}"]`).css('display', 'block');
            } else {
                parent.find('li').css('display', 'block');
            }
            return true;
        }
    }
    return false;
}
window.filterListItems = filterListItems;

const markListItem = function (parentClass, id) {
    if (parentClass) {
        const parent = $(`.${parentClass}`);
        if (parent.length) {
            parent.find('li').removeClass('selected');
            if (id) {
                const elem = parent.find(`li[data-key="${id}"]`);
                if (elem.length) {
                    elem.addClass('selected');
                }
            }
        }
    }
    return false;
}
window.markListItem = markListItem;

const setPeople = function () {
    $(".more-people").click(function (e) {
        $(this).parent(".activity-people-list").toggleClass("open");
    });
};

const setShare = function () {
    //console.log(navigator, navigator.share);
};

const openWindow = function (id, closeOutSideClick = true) {
    lastFocus = document.activeElement
    $("#" + id).trigger("open.cc.modal");
    $(".windows")
        .addClass("on").addClass("open")
        .find(".open").removeClass("open")
    $(".windows")
        .find("#" + id)
        .addClass("open");
    //
    if (closeOutSideClick) {
        $(".windows-bg").unbind("click").bind("click", closeWindow);
    }

    $("#" + id)
        .off('click.website').on('click.website', "[data-action=close]", closeWindow)
        .off('keydown.website').on('keydown.website', "[data-action=close]", e => {
        if (e.keyCode === 13 || e.keyCode === 32) closeWindow();
    });
    //
    document.body.classList && document.body.classList.add('window-open');
    $("#" + id).trigger("opened.cc.modal");
    $("#" + id).attr('aria-hidden', 'false');

    window.removeEventListener('keydown', onWindowKeyDown);
    window.addEventListener('keydown', onWindowKeyDown);

    //focus
    if (!$("#" + id).find(':visible:focusable:not(.window-close):first').focus().length) {
        $("#" + id).find('h2,h3,.window-close').eq(1).focus();
    }
    $('#site').attr('inert', true)
};
/**
 * @param {string} id
 * @param {('reload'|'redirect'|string)} afterClose
 * @param {object} afterCloseData
 */
const closeWindow = function () {
    return new Promise((resolve, reject) => {
        $('#site').removeAttr('inert')
        const opened = $(".windows").find(".open")
        opened.trigger("close.cc.modal");
        opened.attr('aria-hidden', 'true');
        document.body.classList && document.body.classList.remove('window-open');
        $(".windows").removeClass("open");
        window.removeEventListener('keydown', onWindowKeyDown);
        setTimeout(function () {
            $(".windows").removeClass("on");
            opened.removeClass("open");
            $(".windows-bg").unbind("click");
            opened.off("click.website")
            opened.trigger('closed.cc.modal');
            if (typeof lastFocus === 'object') {
                lastFocus.focus()
            }
            resolve();
        }, 400);
    })
};

const onWindowKeyDown = function (e) {
    if (e.code === 'Escape') {
        const tag = document.activeElement.tagName.toLowerCase();
        if (tag == 'input' || tag == 'textarea') {
            return;
        }
        const opened = $(".windows").find(".open");
        if (opened && opened.length) {
            closeWindow();
        }
    } else if (e.code === 'Tab') {
        const opened = $(".windows").find(".open");
        const tababale = [...opened.find('h2[tabindex],a,button,input,textarea,select,[onclick]')];
        const focused = document.activeElement;
        const focusedIndex = tababale.indexOf(focused)
        const withShift = e.shiftKey;
        if ((withShift && focusedIndex === 0) || (!withShift && focusedIndex === tababale.length - 1)) {
            if (!withShift) {
                $(document.body).find('h2[tabindex],a,button,input,textarea,select,[onclick]').last().focus();
            } else {
                e.preventDefault();
            }
        }
    }
};

window.openWindow = openWindow;
window.closeWindow = closeWindow;

// ALERT
const openAlert = function (message, type, duration) {
    return new Promise((success, fail) => {
        var types = "success,error,info,warning";
        var durations = flashDuration ? JSON.parse(flashDuration) : null;
        if (types.indexOf(type) < 0) {
            type = "info";
        }
        if (message.trim().length === 0) {
            success()
        }
        var dur = (durations ? (durations[type] || 3) : 3) * 1000;
        if (type && dur) {
            $(".alert-message-inner").attr("class", "alert-message-inner " + type);
            $(".alert-message-inner").text(message);
            $(".alert-message").addClass("open");
            //
            clearTimeout(window.alertTi);
            window.alertTi = setTimeout(function () {
                $(".alert-message").removeClass("open");
                window.alertTi = setTimeout(function () {
                    $(".alert-message-inner").attr("class", "alert-message-inner");
                    $(".alert-message-inner").text("");
                }, 300);
                success()
            }, dur);
        } else {
            fail()
        }
    })
};
window.alertTi = -1;
window.openAlert = openAlert;

const setTagGroupsPosition = function () {
    var ww = $(window).width();
    if (ww < 768) {
        $('.tag-groups .tag-group-list').each(function () {
            let parent = $(this).parent()[0];
            $(this).css({'top': (parent.offsetTop + parent.clientHeight + 5) + 'px',});
            $(this).addClass('hide');
        });
    }
};

const direction = $('html').attr('dir'),
    leftPadding = 5;

const initCustomScroll = function () {
    const onScroll = function (e) {
        $(this).closest('.tags-wrap-arrowed').removeClass('custom-scroll-start');
        $(this).closest('.tags-wrap-arrowed').removeClass('custom-scroll-end');
        if (direction === 'rtl') {
            if (this.scrollLeft < 0) {
                $(this).closest('.tags-wrap-arrowed').addClass('custom-scroll-start');
            }
            if (this.offsetWidth - this.scrollLeft + leftPadding < this.scrollWidth) {
                $(this).closest('.tags-wrap-arrowed').addClass('custom-scroll-end');
            }
        } else {
            if (this.scrollLeft > 0) {
                $(this).closest('.tags-wrap-arrowed').addClass('custom-scroll-start');
            }
            if (this.offsetWidth + this.scrollLeft < this.scrollWidth) {
                $(this).closest('.tags-wrap-arrowed').addClass('custom-scroll-end');
            }
        }
    }
    const bindArrows = function(scroller) {
        scroller.closest('.tags-wrap').addClass('tags-wrap-arrowed');
        scroller.closest('.tags-wrap-arrowed').find('.custom-scroll-previos').on('click', function (e) {
            e.preventDefault();
            const leftPos = scroller.scrollLeft();
            if (direction === 'rtl') {
                scroller.animate({scrollLeft: leftPos + 200}, 500);
            } else {
                scroller.animate({scrollLeft: leftPos - 200}, 500);
            }
        });
        scroller.closest('.tags-wrap-arrowed').find('.custom-scroll-next').on('click', function (e) {
            e.preventDefault();
            const leftPos = scroller.scrollLeft();
            if (direction === 'rtl') {
                scroller.animate({scrollLeft: leftPos - 200}, 500);
            } else {
                scroller.animate({scrollLeft: leftPos + 200}, 500);
            }
        });
    }
    $('.custom-scroll').each(function () {
        if ($(this).is('ul')) {
            $(this).closest('.tags-wrap').addClass('tags-wrap-arrowed')
            $(this).on('scroll', onScroll).trigger('scroll')
            bindArrows($(this))

        } else {
            const bar = new SimpleBar($(this)[0]);
            bar.getScrollElement().addEventListener('scroll', onScroll)
            bar.getScrollElement().dispatchEvent(new Event('scroll'))
            $(this).find('.simplebar-content-wrapper').removeAttr('tabindex').attr('aria-label', window.translate.tag_group_list_label)
            if ($(this).find('.simplebar-track.simplebar-horizontal').css("visibility") === "visible") {
                const scroller = $(bar.getScrollElement());
                bindArrows(scroller)
            }
        }
    });
}

function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([ab], {type: mimeString});
    return blob;
}

window.dataURLtoBlob = dataURItoBlob;
